import TextField from '@mui/material/TextField';

export const Input = (props: any) => {
    return (
        <div>
            <TextField
                hiddenLabel
                id={props.id}
                name={props.name}
                defaultValue={props.defaultValue}
                type={props.type}
                value={props.value}
                variant={props.variant}
                size={props.size}
                sx={props.sx}
                onChange={props.onChange}
                onBlur={props.onBlur}
                placeholder={props.placeholder}
                required={props.required}
                maxRows={props.maxRows}
                multiline={props.multiline}
            />
        </div>
    );
}
